import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Tooltip, OverlayTrigger, Modal } from 'react-bootstrap';
import DynamicFormModal, { ENTITY_CONFIGS } from '../../../formBuilder/wrappers/DynamicFormModal';
import {
    archiveFacility,
    unArchiveFacility,
    deleteFacility
} from '../../../../services/clinicPortalServices/facilityServices';
import { getUserRole } from '../../../../services/common/util';
import Swal from 'sweetalert2';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { trackRecentView } from '../../../../services/clinicPortalServices/recentViewService';

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showPanel: false,
            facilityId: props.data.facility._id
        };
    }

    renderPanel() {
        const f = this.props.data.facility;
        const ps = {
            overlay: { position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.3)',zIndex:1040 },
            panel: { position:'fixed',top:0,right:0,width:'420px',height:'100vh',background:'#fff',boxShadow:'-4px 0 20px rgba(0,0,0,0.15)',zIndex:1041,display:'flex',flexDirection:'column',overflowY:'auto' },
            header: { padding:'16px 20px',borderBottom:'1px solid #e0e0e0',display:'flex',alignItems:'center',justifyContent:'space-between',background:'#f8f9fa' },
            title: { margin:0,fontSize:'16px',fontWeight:600,color:'#333' },
            body: { padding:'20px',flex:1 },
            section: { marginBottom:'20px' },
            sectionTitle: { fontSize:'11px',fontWeight:700,color:'#888',letterSpacing:'0.08em',textTransform:'uppercase',marginBottom:'10px',paddingBottom:'6px',borderBottom:'1px solid #eee' },
            dl: { display:'grid',gridTemplateColumns:'140px 1fr',rowGap:'8px',margin:0 },
            dt: { fontSize:'13px',color:'#555',fontWeight:600,paddingRight:'8px' },
            dd: { fontSize:'13px',color:'#222',margin:0 },
            editBtn: { background:'#0066cc',color:'#fff',border:'none',borderRadius:'4px',padding:'6px 14px',fontSize:'13px',cursor:'pointer',marginRight:'8px' },
            closeBtn: { background:'transparent',border:'none',fontSize:'18px',cursor:'pointer',color:'#666' }
        };
        const a = f.address && typeof f.address === 'object' ? f.address : { address1: f.address, city: f.city, state: f.state, zip: f.zip };
        const address = [a.address1 || a.street || a.line1, a.address2, a.city, a.state, a.zip].filter((x) => x && typeof x === 'string').join(', ');
        const isArchived = f.archived === 'archived';
        return ReactDOM.createPortal(
            <>
                <div style={ps.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={ps.panel}>
                    <div style={ps.header}>
                        <h5 style={ps.title}>Facility Details</h5>
                        <div>
                            <button style={ps.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}><i className="fas fa-pen" style={{ marginRight:5 }}></i>Edit</button>
                            <button style={ps.closeBtn} onClick={() => this.setState({ showPanel: false })}><i className="fas fa-times"></i></button>
                        </div>
                    </div>
                    <div style={ps.body}>
                        <div style={ps.section}>
                            <div style={ps.sectionTitle}>Facility Information</div>
                            <dl style={ps.dl}>
                                <dt style={ps.dt}>Name</dt><dd style={ps.dd}>{f.name || '—'}</dd>
                                <dt style={ps.dt}>NPI</dt><dd style={ps.dd}>{f.npi || '—'}</dd>
                                <dt style={ps.dt}>Phone</dt><dd style={ps.dd}>{f.phone_no || f.contact_phone || f.phone || f.mobile || '—'}</dd>
                                <dt style={ps.dt}>Fax</dt><dd style={ps.dd}>{f.fax_no || f.fax || '—'}</dd>
                                <dt style={ps.dt}>Email</dt><dd style={ps.dd}>{f.contact_email || f.email || '—'}</dd>
                                <dt style={ps.dt}>Address</dt><dd style={ps.dd}>{address || '—'}</dd>
                                <dt style={ps.dt}>Fax Type</dt><dd style={ps.dd}>{f.fax_type || 'NoFax'}</dd>
                                <dt style={ps.dt}>Email Notifications</dt><dd style={ps.dd}>{f.email_notifications_enabled ? <span style={{ color: '#198754', fontWeight: 600 }}>Yes</span> : 'No'}</dd>
                                <dt style={ps.dt}>EHR Result Delivery</dt><dd style={ps.dd}>{f.ehr_delivery_enabled ? <span style={{ color: '#198754', fontWeight: 600 }}>Yes</span> : 'No'}</dd>
                                <dt style={ps.dt}>Invoice Processing</dt><dd style={ps.dd}>{f.invoice_processing ? <span style={{ color: '#198754', fontWeight: 600 }}>Yes</span> : 'No'}</dd>
                                <dt style={ps.dt}>First Inconclusive Release</dt><dd style={ps.dd}>{f.first_inconclusive_release ? <span style={{ color: '#198754', fontWeight: 600 }}>Yes</span> : 'No'}</dd>
                                <dt style={ps.dt}>Status</dt>
                                <dd style={ps.dd}>
                                    <span style={{ color: isArchived ? '#dc3545' : '#28a745', fontWeight:600 }}>
                                        {isArchived ? 'Archived' : 'Active'}
                                    </span>
                                </dd>
                            </dl>
                        </div>
                        {f.contacts && f.contacts.length > 0 && (
                            <div style={ps.section}>
                                <div style={ps.sectionTitle}>Contacts</div>
                                {f.contacts.map((c, i) => (
                                    <div key={i} style={{ fontSize:'13px',padding:'4px 0',borderBottom:'1px solid #f0f0f0' }}>
                                        <strong>{[c.first_name, c.last_name].filter(Boolean).join(' ')}</strong>
                                        {c.title && <span style={{ color:'#888',marginLeft:6 }}>{c.title}</span>}
                                        {c.email && <div style={{ color:'#555' }}>{c.email}</div>}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </>,
            document.body
        );
    }

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Facility
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete Facility
        </Tooltip>
    );

    handleShow = () => {
        this.setState({ show: true }, () => {
            let elements = document.getElementsByClassName('removeTabIndexModal');
            if (elements.length) {
                for (let i = 0; i < elements.length; i++) {
                    let dialog = elements[i];
                    dialog.parentNode.removeAttribute('tabindex');
                }
            }
        });
        // Track recent view
        const facility = this.props.data.facility;
        if (facility) {
            trackRecentView('facility', facility._id, facility.name || 'Facility', '/clinic/facility');
        }
    };

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this facility!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const facilityInfo = {
                    _id: this.state.facilityId,
                    name: this.props.data.facility.name
                };
                deleteFacility(facilityInfo).then((response) => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    renderTooltipArchive = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Archive Facility
        </Tooltip>
    );

    archiveFacility = () => {
        Swal.fire({
            title: 'Archive Facility',
            text: 'You are about to archive ' + this.props.data.facility.name,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                archiveFacility(this.props.data.facility._id).then((facilityRes) => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    renderTooltipUnArchive = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Release Archived Facility
        </Tooltip>
    );

    unArchiveFacility = () => {
        unArchiveFacility(this.props.data.facility._id).then((facilityRes) => {
            this.props.context.componentParent.loadGridData();
        });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        return (
            <div style={{ textAlign: 'left' }}>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View Facility</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn">
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button onClick={this.handleShow} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                {/* {
					!(/customerserviceuser|^admin/.test(getUserRole().toLowerCase())) &&
					<OverlayTrigger
						placement="top"
						delay={{ show: 50, hide: 100 }}
						overlay={this.renderTooltipDelete}
					>
						<button onClick={this.handleDelete} className="edit-order-btn">
							<i className="fas fa-trash"></i>
						</button>
					</OverlayTrigger>
				} */}
                {!/customerserviceuser|^admin/.test(getUserRole().toLowerCase()) && (
                    <>
                        {this.props.data.facility.archived === 'archived' && (
                            <>
                                <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 50, hide: 100 }}
                                    overlay={this.renderTooltipUnArchive}
                                >
                                    <button onClick={this.unArchiveFacility} className="edit-order-btn">
                                        <i className="fas fa-lock-open"></i>
                                    </button>
                                </OverlayTrigger>
                            </>
                        )}
                        {this.props.data.facility.archived !== 'archived' && (
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 50, hide: 100 }}
                                overlay={this.renderTooltipArchive}
                            >
                                <button onClick={this.archiveFacility} className="edit-order-btn">
                                    <i className="fas fa-lock"></i>
                                </button>
                            </OverlayTrigger>
                        )}
                    </>
                )}
                <ModalStyled
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                    dialogClassName="removeTabIndexModal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Update Facility Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <DynamicFormModal
                            entityType="facility"
                            entityId={this.state.facilityId}
                            entityConfig={ENTITY_CONFIGS.facility}
                            context={this.props.context}
                            handleClose={this.handleClose}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
